module.exports = __webpack_public_path__ + "img/c-1.9bf02b3f.png";